
import { Link, useParams } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { useCallback } from "react";
import { toast } from 'react-toastify';

export const UserBookCover = ({image, bookId, alt="", creative=false, editiable=false})=>{
    const { school } = useParams();
    const queryClient = useQueryClient();
    
    // 표지 등록
    const coverUploadMutate = useMutation({
        mutationFn:(data)=>Api.post('/api/userBook/cover/file', data, {
            headers:{
                "X-Requested-With": "XMLHttpRequest",
                'Content-Type': "multipart/form-data"
            }
        }),
        onSuccess:(res)=>{
            const userBook = queryClient.getQueryData(['userbook', bookId]);
            queryClient.setQueryData(['userbook', bookId], {...userBook, data:{...userBook.data, image:res.data}});
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
        }
    });
    
    const onChangeCoverFile = (evt)=>{
        if(coverUploadMutate.isPending) return;
        if (evt.target.files.length > 0) {
            const file = evt.target.files[0];

            let formData = new FormData();
            formData.append('id', bookId);
            formData.append('coverFile', file);

            coverUploadMutate.mutate(formData);
        }
    }


    // 표지 삭제
    const coverDeleteMutate = useMutation({
        mutationFn:()=>Api.get(`/api/userBook/${bookId}/cover/delete`),
        onSuccess:()=>{
            const userBook = queryClient.getQueryData(['userbook', bookId]);
            queryClient.setQueryData(['userbook', bookId], {...userBook, data:{...userBook.data, image:null}});
        },
        onError:(err)=>{
            const errorData = createFetchErrorMessage(err);
            toast.error(errorData.message);
        }
    })

    const onDeleteCover = useCallback(() => {
        if(coverDeleteMutate.isPending)return;
        if (window.confirm("표지를 삭제하시겠습니까?")) {
            coverDeleteMutate.mutate();
        }
    }, [coverDeleteMutate]);

    return (
    <div className="cover">
        <div>
            { image && <img src={image} alt={alt} /> }
            { !image && <img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_cover_no_image.jpg`} alt="표지 없음" /> }
            <div className="etc">
                {creative && <div className="ribbon creative"><span>창작</span></div>}
            </div>
            {editiable &&
                <>
                    {image !== null &&
                        <button className="delete_cover" onClick={onDeleteCover}><i className="fas fa-times"></i></button>
                    }
                    <Link className="btn paint" to={`/${school}/userbook/cover/${bookId}`}><img src={`${process.env.PUBLIC_URL}/static/images/userbook/paint_icon.png`} alt="표지 그림" /></Link>
                    <input type="file" name="coverFile" className="hidden" onChange={onChangeCoverFile} id="coverFile" accept="image/png, image/jpeg" />
                    <label className="btn picture" htmlFor="coverFile" >
                        <img src={`${process.env.PUBLIC_URL}/static/images/userbook/picture_icon.png`} alt="표지 사진" />
                    </label>
                </>
            }
        </div>
    </div>
    );
};